import React, { useState } from 'react';
import Modal from '../Modal';

const EarlyBirdModal = () => {
  const [showDialog, setShowDialog] = useState(false);

  const close = () => setShowDialog(false);

  const open = () => setShowDialog(true);

  return (
    <>
      <span className="earlybird__trigger">
        <button className="button button--link" onClick={open}>
          <img
            src="/img/spareroom/v4/icons/early_bird.svg?v=1"
            className="svg early_bird_icon"
            alt="Early bird"
            width="212"
            height="150"
          ></img>
          {'Early Bird Access '}

          <i className="fas fa-info-circle"></i>
        </button>
      </span>
      {showDialog ? (
        <Modal
          close={close}
          showDialog={showDialog}
          modalLabelText="Early Bird"
          id="early_bird_info"
          initialFocus=".modal__close"
        >
          <p>
            Early Bird Access is just one benefit of upgrading. With it you can
            contact all ads on the site as soon as they appear - otherwise
            you&lsquo;ll have to wait 7 days before you can contact any ads with
            the Early Bird icon.{' '}
            <a
              href="/content/info-faq/how-the-site-works"
              title="About Early Bird Access"
            >
              Find out more &raquo;
            </a>
          </p>
        </Modal>
      ) : null}
    </>
  );
};

export default EarlyBirdModal;
